import * as React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';
import translations from './translations';

import { addLocaleData } from "react-intl";
import * as locale_de from "react-intl/locale-data/de";
import * as locale_en from "react-intl/locale-data/en";
import * as locale_fi from "react-intl/locale-data/fi";
import messages_de from "./../../translations/de.json";
import messages_en from "./../../translations/en.json";
import messages_fi from "./../../translations/fi.json";

addLocaleData([...locale_en, ...locale_de, ...locale_fi]);

const messages = {
  de: messages_de,
  en: messages_en,
  fi: messages_fi,
};
interface IProps {
  message: string
  transitionAllowed: any
}

interface IState {
  show: boolean
}

export class TransitionModal extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = {
      show: false
    }
  }

  public componentWillMount() {
    this.setState({show: true})
  }

  public render() {
    return(
      <IntlProvider locale={localStorage.getItem("locale") || "en"} messages={messages[localStorage.getItem("locale") || "en"]} >
      <div className={"modal" + (this.state.show? ' is-active' : '')}>
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title"><FormattedMessage {...translations.title} /></p>
          </header>
          <section className="modal-card-body">
            {this.props.message}
          </section>
          <footer className="modal-card-foot">
            <button className="button is-info" onClick={this.goForIt}><FormattedMessage {...translations.leave} /></button>
            <button className="button is-info" onClick={this.cancelTransition} ><FormattedMessage {...translations.back} /></button>
          </footer>
        </div>
      </div>
      </IntlProvider>
    )
  }

  private goForIt = () => {
    this.setState({show: false})
    this.props.transitionAllowed(true)
  }

  private cancelTransition = () => {
    this.setState({show: false})
    this.props.transitionAllowed(false)
  }
}



// WEBPACK FOOTER //
// ./src/components/TransitionModal/index.tsx